export const ROUTE_MAP: Record<string, string> = {
  "ActividadesClienteAccionesDevolucionInteresesScript": "/actividades-cliente-acciones-devolucion-intereses-script",
  "ActividadesClienteAccionesJudicialesScript": "/actividades-cliente-acciones-judiciales-script",
  "ActividadesClienteContador": "/actividades-cliente-contador",
  "ActividadesClienteHeader": "/actividades-cliente-header",
  "ActividadesClienteHijo": "/actividades-cliente-hijo",
  "ActividadesClienteHijoCompensacionAcuerdoAcreedoresContador": "/actividades-cliente-hijo-compensacion-acuerdo-acreedores-contador",
  "ActividadesClienteHijoCompensacionAcuerdoAcreedoresScript": "/actividades-cliente-hijo-compensacion-acuerdo-acreedores-script",
  "ActividadesClienteHijoDevolucionInteresesContador": "/actividades-cliente-hijo-devolucion-intereses-contador",
  "ActividadesClienteHijoSolicitudBajaScript": "/actividades-cliente-hijo-solicitud-baja-script",
  "ActividadesClienteMonitorioContadorIdentificador": "/actividades-cliente-monitorio-contador-identificador",
  "ActividadesClienteMonitorioScript": "/actividades-cliente-monitorio-script",
  "ActividadesClienteMonitoriosContador": "/actividades-cliente-monitorios-contador",
  "ActividadesClienteMonitoriosHeader": "/actividades-cliente-monitorios-header",
  "ActividadesClienteMonitoriosList": "/actividades-cliente-monitorios-list",
  "ActividadesClienteScript": "/actividades-cliente-script",
  "CalculadoraLSOPorcentajeCuotaAnnadido": "/calculadora-lso-porcentaje-cuota-annadido",
  "CalculadoraLSORangoCuota": "/calculadora-lso-rango-cuota",
  "CarterasList": "/carteras-list",
  "ClienteActualizacionesContador": "/cliente-actualizaciones-contador",
  "ClienteActualizacionesHeader": "/cliente-actualizaciones-header",
  "ClienteActualizacionesScript": "/cliente-actualizaciones-script",
  "ClienteCombo": "/cliente-combo",
  "ClienteContactoCorreosScript": "/cliente-contacto-correos-script",
  "ClienteContactoTelefonosScript": "/cliente-contacto-telefonos-script",
  "ClienteContador": "/cliente-contador",
  "ClienteContadorContrato": "/cliente-contador-contrato",
  "ClienteDatosAcreditaResidenciaScript": "/cliente-datos-acredita-residencia-script",
  "ClienteDatosAntecedentesPenalesScript": "/cliente-datos-antecedentes-penales-script",
  "ClienteDatosDiscapacidadScript": "/cliente-datos-discapacidad-script",
  "ClienteDatosEmbargosActivosHeader": "/cliente-datos-embargos-activos-header",
  "ClienteDatosEmbargosActivosScript": "/cliente-datos-embargos-activos-script",
  "ClienteDatosFamiliaresCargoHeader": "/cliente-datos-familiares-cargo-header",
  "ClienteDatosFamiliaresCargoScript": "/cliente-datos-familiares-cargo-script",
  "ClienteDatosGastosMensualesHeader": "/cliente-datos-gastos-mensuales-header",
  "ClienteDatosGastosMensualesScript": "/cliente-datos-gastos-mensuales-script",
  "ClienteDatosHerenciaHeader": "/cliente-datos-herencia-header",
  "ClienteDatosHerenciaScript": "/cliente-datos-herencia-script",
  "ClienteDatosInmueblesHeader": "/cliente-datos-inmuebles-header",
  "ClienteDatosInmueblesScript": "/cliente-datos-inmuebles-script",
  "ClienteDatosLsoPreviaScript": "/cliente-datos-lso-previa-script",
  "ClienteDatosOtrosActivosHeader": "/cliente-datos-otros-activos-header",
  "ClienteDatosOtrosActivosScript": "/cliente-datos-otros-activos-script",
  "ClienteDatosPoseeAlgunaSociedadHeader": "/cliente-datos-posee-alguna-sociedad-header",
  "ClienteDatosPoseeAlgunaSociedadScript": "/cliente-datos-posee-alguna-sociedad-script",
  "ClienteDatosSancionesHaciendaSSHeader": "/cliente-datos-sanciones-hacienda-ss-header",
  "ClienteDatosSancionesHaciendaSSScript": "/cliente-datos-sanciones-hacienda-ss-script",
  "ClienteDatosVehiculosHeader": "/cliente-datos-vehiculos-header",
  "ClienteDatosVehiculosScript": "/cliente-datos-vehiculos-script",
  "ClienteDatosVentaDonacionBienHeader": "/cliente-datos-venta-donacion-bien-header",
  "ClienteDatosVentaDonacionBienScript": "/cliente-datos-venta-donacion-bien-script",
  "ClienteEdicion": "/cliente-edicion",
  "ClienteEdicionCOPIA": "/cliente-edicion-copia",
  "ClienteEstadoPausaScript": "/cliente-estado-pausa-script",
  "ClienteHeader": "/cliente-header",
  "ClienteHistoricoAsignacionScript": "/cliente-historico-asignacion-script",
  "ClienteHistoricoEstadosClienteScript": "/cliente-historico-estados-cliente-script",
  "ClienteHistoricoEstadosScript": "/cliente-historico-estados-script",
  "ClienteList": "/cliente-list",
  "ClienteNoCobrarComisionContador": "/cliente-no-cobrar-comision-contador",
  "ClienteNoCobrarComisionHeader": "/cliente-no-cobrar-comision-header",
  "ClienteNoCobrarComisionList": "/cliente-no-cobrar-comision-list",
  "ClienteNoCobrarComisionScript": "/cliente-no-cobrar-comision-script",
  "ClienteObservacionesProcesoLSOScript": "/cliente-observaciones-proceso-lso-script",
  "ClienteObservacionesScript": "/cliente-observaciones-script",
  "ClientePrediccionScript": "/cliente-prediccion-script",
  "ClienteProcesoLSO": "/cliente-proceso-lso",
  "ClienteProcesoLSOScript": "/cliente-proceso-lso-script",
  "ClientePrueba": "/cliente-prueba",
  "ClienteScript": "/cliente-script",
  "ClienteVinculoScript": "/cliente-vinculo-script",
  "ComisionesGruposContador": "/comisiones-grupos-contador",
  "ComisionesList": "/comisiones-list",
  "ComisionesScript": "/comisiones-script",
  "DatosMaestrosList": "/datos-maestros-list",
  "DespachosCombo": "/despachos-combo",
  "DespachosScript": "/despachos-script",
  "Deuda": "/deuda",
  "DeudaClienteAccionesJudicialesContador": "/deuda-cliente-acciones-judiciales-contador",
  "DeudaClienteAccionesJudicialesHeader": "/deuda-cliente-acciones-judiciales-header",
  "DeudaClienteAccionesJudicialesList": "/deuda-cliente-acciones-judiciales-list",
  "DeudaClienteAccionesJudicialesScript": "/deuda-cliente-acciones-judiciales-script",
  "DeudaClienteAddendum": "/deuda-cliente-addendum",
  "DeudaClienteAddendumScript": "/deuda-cliente-addendum-script",
  "DeudaClienteCombo": "/deuda-cliente-combo",
  "DeudaClienteContador": "/deuda-cliente-contador",
  "DeudaClienteDemandaCombo": "/deuda-cliente-demanda-combo",
  "DeudaClienteDemandaContadorDemanda": "/deuda-cliente-demanda-contador-demanda",
  "DeudaClienteDemandaContadorDiligencia": "/deuda-cliente-demanda-contador-diligencia",
  "DeudaClienteDemandaContadorOposicion": "/deuda-cliente-demanda-contador-oposicion",
  "DeudaClienteDemandaHistoricoEstadosAccionScript": "/deuda-cliente-demanda-historico-estados-accion-script",
  "DeudaClienteDemandaHistoricoEstadosApudScript": "/deuda-cliente-demanda-historico-estados-apud-script",
  "DeudaClienteDemandaScript": "/deuda-cliente-demanda-script",
  "DeudaClienteGestorScript": "/deuda-cliente-gestor-script",
  "DeudaClienteIdentificadorContadorScript": "/deuda-cliente-identificador-contador-script",
  "DeudaClientePrograma": "/deuda-cliente-programa",
  "DeudaClienteProgramaHeader": "/deuda-cliente-programa-header",
  "DeudaClienteScript": "/deuda-cliente-script",
  "DeudaMicroprestamoClienteContador": "/deuda-microprestamo-cliente-contador",
  "DeudaScript": "/deuda-script",
  "DeudasHeader": "/deudas-header",
  "DeudasList": "/deudas-list",
  "DeudasMicroprestamosHeader": "/deudas-microprestamos-header",
  "DeudasMicroprestamosList": "/deudas-microprestamos-list",
  "DevolucionInteresesClienteContador": "/devolucion-intereses-cliente-contador",
  "DevolucionInteresesClienteHeader": "/devolucion-intereses-cliente-header",
  "DevolucionInteresesClienteHistoricoEstadosScript": "/devolucion-intereses-cliente-historico-estados-script",
  "DevolucionInteresesClienteList": "/devolucion-intereses-cliente-list",
  "DocumentTemplate": "/document-template",
  "DocumentoComprobanteScript": "/documento-comprobante-script",
  "DocumentoContador": "/documento-contador",
  "DocumentoContadorContrato": "/documento-contador-contrato",
  "DocumentoDemanda": "/documento-demanda",
  "DocumentoDeudaCliente": "/documento-deuda-cliente",
  "DocumentoFirmaPendienteScript": "/documento-firma-pendiente-script",
  "DocumentoGlobalContador": "/documento-global-contador",
  "DocumentoGlobalHeader": "/documento-global-header",
  "DocumentoGlobalList": "/documento-global-list",
  "DocumentoHeader": "/documento-header",
  "DocumentoScript": "/documento-script",
  "EntidadesCombo": "/entidades-combo",
  "EntidadesContador": "/entidades-contador",
  "EntidadesCorreos": "/entidades-correos",
  "EntidadesDeudaClienteActividadesExtrajudicial": "/entidades-deuda-cliente-actividades-extrajudicial",
  "EntidadesHeader": "/entidades-header",
  "EntidadesList": "/entidades-list",
  "EntidadesPublicasScript": "/entidades-publicas-script",
  "EntidadesScript": "/entidades-script",
  "EntidadesTelefonoCombo": "/entidades-telefono-combo",
  "Equipos": "/equipos",
  "EquiposScript": "/equipos-script",
  "EstadoCivil": "/estado-civil",
  "EstadosAccionCombo": "/estados-accion-combo",
  "EstadosAccionesJudiciales": "/estados-acciones-judiciales",
  "EstadosApudAccionCombo": "/estados-apud-accion-combo",
  "EstadosClienteList": "/estados-cliente-list",
  "EstadosClientePausaScript": "/estados-cliente-pausa-script",
  "EstadosCombo": "/estados-combo",
  "EstadosComboCliente": "/estados-combo-cliente",
  "EstadosComboLead": "/estados-combo-lead",
  "EstadosCompensacionAcuerdoAcreedores": "/estados-compensacion-acuerdo-acreedores",
  "EstadosDeudaCliente": "/estados-deuda-cliente",
  "EstadosDeudaClienteDemanda": "/estados-deuda-cliente-demanda",
  "EstadosDevolucionIntereses": "/estados-devolucion-intereses",
  "EstadosLeyenda": "/estados-leyenda",
  "EstadosList": "/estados-list",
  "EstadosMonitorioCombo": "/estados-monitorio-combo",
  "EstadosMonitorioResultadoEstudioCombo": "/estados-monitorio-resultado-estudio-combo",
  "EstadosMovimiento": "/estados-movimiento",
  "EstadosProcesoLSO": "/estados-proceso-lso",
  "FacturaCalificacionOperacionCombo": "/factura-calificacion-operacion-combo",
  "FacturaClaveRegimenCombo": "/factura-clave-regimen-combo",
  "FacturaImpuestoCombo": "/factura-impuesto-combo",
  "FacturaOperacionExentaCombo": "/factura-operacion-exenta-combo",
  "FacturaSerieScript": "/factura-serie-script",
  "FacturaTipoFacturasCombo": "/factura-tipo-facturas-combo",
  "FacturasContentContador": "/facturas-content-contador",
  "FacturasDetalleScript": "/facturas-detalle-script",
  "FacturasHeader": "/facturas-header",
  "FacturasScript": "/facturas-script",
  "Genero": "/genero",
  "Hijos": "/hijos",
  "InformacionGeneralCorreosScript": "/informacion-general-correos-script",
  "InformacionGeneralScript": "/informacion-general-script",
  "InterposicionDemandaCombo": "/interposicion-demanda-combo",
  "JuzgadosCombo": "/juzgados-combo",
  "JuzgadosComboCCAA": "/juzgados-combo-ccaa",
  "JuzgadosComboCodigo": "/juzgados-combo-codigo",
  "JuzgadosComboMunicipio": "/juzgados-combo-municipio",
  "JuzgadosComboProvincia": "/juzgados-combo-provincia",
  "JuzgadosContador": "/juzgados-contador",
  "JuzgadosHeader": "/juzgados-header",
  "JuzgadosList": "/juzgados-list",
  "JuzgadosScript": "/juzgados-script",
  "LeadCabeceraBase": "/lead-cabecera-base",
  "LeadContador": "/lead-contador",
  "LeadEdicion": "/lead-edicion",
  "LeadEdicionDocumentoPrueba": "/lead-edicion-documento-prueba",
  "LeadEdicionOLD2805": "/lead-edicion-old2805",
  "LeadEdicionORIGINAL": "/lead-edicion-original",
  "LeadEdicionOriginalBK": "/lead-edicion-original-bk",
  "LeadEdicionPrueba": "/lead-edicion-prueba",
  "LeadHeader": "/lead-header",
  "LeadList": "/lead-list",
  "LeadScript": "/lead-script",
  "LoginColl": "/login-coll",
  "MaestroAcreditaResidenciaScript": "/maestro-acredita-residencia-script",
  "MaestroActivosSituacionScript": "/maestro-activos-situacion-script",
  "MaestroActivosTipoScript": "/maestro-activos-tipo-script",
  "MaestroCasadoRegimenEconomicoScript": "/maestro-casado-regimen-economico-script",
  "MaestroDeudaMotivoPrestamoScript": "/maestro-deuda-motivo-prestamo-script",
  "MaestroDeudaOrigenScript": "/maestro-deuda-origen-script",
  "MaestroDeudaProcedimientoScript": "/maestro-deuda-procedimiento-script",
  "MaestroDeudaTitularScript": "/maestro-deuda-titular-script",
  "MaestroDiscapacidadScript": "/maestro-discapacidad-script",
  "MaestroEstadoCivilScript": "/maestro-estado-civil-script",
  "MaestroFamiliaresRelacionScript": "/maestro-familiares-relacion-script",
  "MaestroGastosMensualesScript": "/maestro-gastos-mensuales-script",
  "MaestroHerenciasEstadoScript": "/maestro-herencias-estado-script",
  "MaestroHerenciasTipoScript": "/maestro-herencias-tipo-script",
  "MaestroInmueblesHipotecaScript": "/maestro-inmuebles-hipoteca-script",
  "MaestroInmueblesSituacionScript": "/maestro-inmuebles-situacion-script",
  "MaestroInmueblesTipoScript": "/maestro-inmuebles-tipo-script",
  "MaestroMotivoSolicitudBajaScript": "/maestro-motivo-solicitud-baja-script",
  "MaestroNivelAcademicoScript": "/maestro-nivel-academico-script",
  "MaestroOficiosCombo": "/maestro-oficios-combo",
  "MaestroPaisesScript": "/maestro-paises-script",
  "MaestroSociedadesEstadoScript": "/maestro-sociedades-estado-script",
  "MaestroSociedadesTipoScript": "/maestro-sociedades-tipo-script",
  "MaestroTipoContratoScript": "/maestro-tipo-contrato-script",
  "MaestroVariablesScript": "/maestro-variables-script",
  "MaestroVehiculosFinanciacionScript": "/maestro-vehiculos-financiacion-script",
  "MaestroVehiculosSituacionScript": "/maestro-vehiculos-situacion-script",
  "MaestroVehiculosTipoScript": "/maestro-vehiculos-tipo-script",
  "MaestroVehiculosUsoScript": "/maestro-vehiculos-uso-script",
  "MaestroVentaBienTipoScript": "/maestro-venta-bien-tipo-script",
  "MatrizDescuentoAumentadoScript": "/matriz-descuento-aumentado-script",
  "MatrizDescuentoSimpleScript": "/matriz-descuento-simple-script",
  "MatrizInteresesScript": "/matriz-intereses-script",
  "MatrizList": "/matriz-list",
  "MediosPagosHeader": "/medios-pagos-header",
  "MensajeriaBusquedaScript": "/mensajeria-busqueda-script",
  "MensajeriaChatFechaContador": "/mensajeria-chat-fecha-contador",
  "MensajeriaChatListadoContador": "/mensajeria-chat-listado-contador",
  "MensajeriaChatListadoScript": "/mensajeria-chat-listado-script",
  "MensajeriaContadorScript": "/mensajeria-contador-script",
  "MensajeriaList": "/mensajeria-list",
  "MensajeriaMediaScript": "/mensajeria-media-script",
  "MensajeriaPlantillaScript": "/mensajeria-plantilla-script",
  "MensajeriaScript": "/mensajeria-script",
  "MensajeriaTextoScript": "/mensajeria-texto-script",
  "MensajeriaUltimoScript": "/mensajeria-ultimo-script",
  "MenuHijo": "/menu-hijo",
  "MenuPadre": "/menu-padre",
  "MovimientoContadorComision": "/movimiento-contador-comision",
  "MovimientoContadorComisionExito": "/movimiento-contador-comision-exito",
  "MovimientoContadorComisionExitoCompensacionAcuerdoAcreedores": "/movimiento-contador-comision-exito-compensacion-acuerdo-acreedores",
  "MovimientoContadorComisionMensual": "/movimiento-contador-comision-mensual",
  "MovimientoContadorCompensacionAcuerdoAcreedores": "/movimiento-contador-compensacion-acuerdo-acreedores",
  "MovimientoContadorCostas": "/movimiento-contador-costas",
  "MovimientoContadorDevolucion": "/movimiento-contador-devolucion",
  "MovimientoContadorDevolucionInteresAcreedor": "/movimiento-contador-devolucion-interes-acreedor",
  "MovimientoContadorDevolucionInteresCliente": "/movimiento-contador-devolucion-interes-cliente",
  "MovimientoContadorFinanciera": "/movimiento-contador-financiera",
  "MovimientoContadorPrimeraAportacion": "/movimiento-contador-primera-aportacion",
  "MovimientoContadorRectificativa": "/movimiento-contador-rectificativa",
  "MovimientosAportacionesContador": "/movimientos-aportaciones-contador",
  "MovimientosAportacionesHeader": "/movimientos-aportaciones-header",
  "MovimientosClienteContador": "/movimientos-cliente-contador",
  "MovimientosComisionContador": "/movimientos-comision-contador",
  "MovimientosComisionHeader": "/movimientos-comision-header",
  "MovimientosContador": "/movimientos-contador",
  "MovimientosCostasContador": "/movimientos-costas-contador",
  "MovimientosCostasHeader": "/movimientos-costas-header",
  "MovimientosFacturacionContador": "/movimientos-facturacion-contador",
  "MovimientosFacturacionHeader": "/movimientos-facturacion-header",
  "MovimientosFinancierasContador": "/movimientos-financieras-contador",
  "MovimientosFinancierasHeader": "/movimientos-financieras-header",
  "MovimientosGlobalHeader": "/movimientos-global-header",
  "MovimientosList": "/movimientos-list",
  "MovimientosListCopia": "/movimientos-list-copia",
  "MovimientosPlanDePagosContador": "/movimientos-plan-de-pagos-contador",
  "MovimientosPlanDePagosHeader": "/movimientos-plan-de-pagos-header",
  "MovimientosPlanDePagosList": "/movimientos-plan-de-pagos-list",
  "MovimientosScript": "/movimientos-script",
  "NivelAcademico": "/nivel-academico",
  "NotificacionesScript": "/notificaciones-script",
  "OficiosCombo": "/oficios-combo",
  "OrigenLeadCombo": "/origen-lead-combo",
  "OrigenLeadContentFiltro": "/origen-lead-content-filtro",
  "OrigenLeadList": "/origen-lead-list",
  "OrigenLeadScript": "/origen-lead-script",
  "Pagos": "/pagos",
  "PagosLog": "/pagos-log",
  "PagosMedios": "/pagos-medios",
  "PagosSuscripcion": "/pagos-suscripcion",
  "PaisesCombo": "/paises-combo",
  "ParametrosCalculadora": "/parametros-calculadora",
  "PayoutWitmeScript": "/payout-witme-script",
  "PlanDePagosScript": "/plan-de-pagos-script",
  "PlanesLiquidacionPDF": "/planes-liquidacion-pdf",
  "PlanesLiquidacionScript": "/planes-liquidacion-script",
  "PrediccionVariableScript": "/prediccion-variable-script",
  "ProcesoLSOClienteDatosScript": "/proceso-lso-cliente-datos-script",
  "ProcesoLSOContador": "/proceso-lso-contador",
  "ProcesoLSODeudaCliente": "/proceso-lso-deuda-cliente",
  "ProcesoLSODeudaClienteHeader": "/proceso-lso-deuda-cliente-header",
  "ProcesoLSODocumentacionPreviaScript": "/proceso-lso-documentacion-previa-script",
  "ProcesoLSODocumentoContador": "/proceso-lso-documento-contador",
  "ProcesoLSOEdicion": "/proceso-lso-edicion",
  "ProcesoLSOHeader": "/proceso-lso-header",
  "ProcesoLSOHistoricoEstadosScript": "/proceso-lso-historico-estados-script",
  "ProcesoLSOIdentificadorContador": "/proceso-lso-identificador-contador",
  "ProcesoLSOList": "/proceso-lso-list",
  "ProcesoLSOObservacionesScript": "/proceso-lso-observaciones-script",
  "ProcesoLSOScript": "/proceso-lso-script",
  "ProductoCombo": "/producto-combo",
  "ProductoComboNombre": "/producto-combo-nombre",
  "ProductoList": "/producto-list",
  "ProductoScript": "/producto-script",
  "RangosCuotaList": "/rangos-cuota-list",
  "RangosCuotaScript": "/rangos-cuota-script",
  "SimulacionesDeudaScript": "/simulaciones-deuda-script",
  "SimulacionesLSODeudaScript": "/simulaciones-lso-deuda-script",
  "SimulacionesLSOScript": "/simulaciones-lso-script",
  "SimulacionesScript": "/simulaciones-script",
  "SituacionDeudaCombo": "/situacion-deuda-combo",
  "SmsPlantillaScript": "/sms-plantilla-script",
  "SubtipoActividadesClienteCombo": "/subtipo-actividades-cliente-combo",
  "SubtipoDocumentoComprobante": "/subtipo-documento-comprobante",
  "TarjetaRevolving": "/tarjeta-revolving",
  "TipoAccionJudicial": "/tipo-accion-judicial",
  "TipoActividadesClienteCombo": "/tipo-actividades-cliente-combo",
  "TipoActividadesLead": "/tipo-actividades-lead",
  "TipoActividadesLeadCombo": "/tipo-actividades-lead-combo",
  "TipoActualizacionesClienteCombo": "/tipo-actualizaciones-cliente-combo",
  "TipoCoche": "/tipo-coche",
  "TipoDemandaCombo": "/tipo-demanda-combo",
  "TipoDeuda": "/tipo-deuda",
  "TipoDocumento": "/tipo-documento",
  "TipoEntidadesCombo": "/tipo-entidades-combo",
  "TipoEntidadesList": "/tipo-entidades-list",
  "TipoEntidadesScript": "/tipo-entidades-script",
  "TipoMovimiento": "/tipo-movimiento",
  "TipoOcupacion": "/tipo-ocupacion",
  "TipoProducto": "/tipo-producto",
  "TipoProductoCombo": "/tipo-producto-combo",
  "TipoTarjetaRevolving": "/tipo-tarjeta-revolving",
  "TipoUsuariosCombo": "/tipo-usuarios-combo",
  "TipoUsuariosList": "/tipo-usuarios-list",
  "TipoVivienda": "/tipo-vivienda",
  "UsuariosCombo": "/usuarios-combo",
  "UsuariosDespachosList": "/usuarios-despachos-list",
  "UsuariosDeudaTotal": "/usuarios-deuda-total",
  "UsuariosEquiposClienteList": "/usuarios-equipos-cliente-list",
  "UsuariosEquiposList": "/usuarios-equipos-list",
  "UsuariosEstatus": "/usuarios-estatus",
  "UsuariosFiltroCombo": "/usuarios-filtro-combo",
  "UsuariosFiltroComboChat": "/usuarios-filtro-combo-chat",
  "UsuariosIntegracionesList": "/usuarios-integraciones-list",
  "UsuariosList": "/usuarios-list",
  "UsuariosScript": "/usuarios-script",
  "UsuariosTipoEntidades": "/usuarios-tipo-entidades",
  "WebLayout": "/web-layout",
  "WhatsappConvScript": "/whatsapp-conv-script",
  "WhatsappDialogCanalEditable": "/whatsapp-dialog-canal-editable",
  "WhatsappDialogCanalScript": "/whatsapp-dialog-canal-script",
  "Empresas": "/empresas",
  "Usuarios": "/usuarios",
} as const;
